import { createStructuredSelector } from 'reselect';

import { showOfficeServicesSelector } from '@selectors/filterServicesSelector';

export const officeServicesCatalogModalSelector = createStructuredSelector({
  visible: showOfficeServicesSelector,
});

export type OfficeServicesCatalogModalProps = {
  visible: boolean;
};
